import React, { SVGProps } from 'react';

const BlackjackIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<g clipPath="url(#clip0_22753_112243)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.97694 0.943604C7.59764 0.574021 6.17989 1.39256 5.8103 2.77186L2.57503 14.8461C2.20545 16.2254 3.02398 17.6431 4.40329 18.0127L11.2255 19.8407C12.6048 20.2103 14.0225 19.3918 14.3921 18.0124L17.6274 5.93824C17.997 4.55894 17.1784 3.14118 15.7991 2.7716L8.97694 0.943604ZM10.6045 8.51384C11.0242 8.08876 11.7188 7.67663 12.5671 7.90394C13.6437 8.19242 14.2474 9.24283 13.9527 10.3425C13.6362 11.5237 12.4043 12.0596 10.5589 12.8623L10.5066 12.8851C9.80706 13.1891 9.57922 13.292 9.42326 13.3624L9.42323 13.3624C9.37566 13.3839 9.33478 13.4024 9.28923 13.4226C9.2507 13.3697 9.21953 13.3263 9.18509 13.2784C9.08214 13.1351 8.94989 12.9511 8.50376 12.3484L8.46979 12.3025C7.273 10.6846 6.47408 9.60462 6.79059 8.42338C7.08524 7.32372 8.13325 6.71589 9.20985 7.00437C10.0582 7.23168 10.4537 7.9359 10.6045 8.51384ZM9.4467 4.12434C9.31636 4.61076 8.81638 4.89942 8.32996 4.76909C7.84353 4.63875 7.55487 4.13877 7.68521 3.65235C7.81554 3.16592 8.31552 2.87726 8.80195 3.0076C9.28837 3.13793 9.57703 3.63791 9.4467 4.12434ZM11.4048 17.7778C11.8887 17.9075 12.3861 17.6203 12.5158 17.1364C12.6454 16.6525 12.3583 16.1551 11.8744 16.0255C11.3905 15.8958 10.8931 16.183 10.7634 16.6669C10.6338 17.1508 10.9209 17.6482 11.4048 17.7778Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_22753_112243">
					<rect
						width="20"
						height="20"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default BlackjackIcon;
